// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__39Y2G","additionalInfo":"AgreementModal_additionalInfo__17bgA"};